import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as CloseCircle } from 'assets/svg/icon-close-circle.svg'

function IconCloseCircle(props: IconProps): JSX.Element {
  const title = 'icon-close-circle'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <CloseCircle {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconCloseCircle
